import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import {
  AnalyticsEventData,
  AnalyticsEventImportance,
  AnalyticsEventName,
  logEvent as logAnalyticsEvent,
} from '@cbhq/client-analytics';

import { useClientProps } from '../../ProfileMenu/providers/ClientPropsProvider';
import { PACKAGE_VERSION } from '../../version';

export function useAnalytics() {
  const { projectId, action } = useClientProps();
  const { locale } = useIntl();

  const logEvent = useCallback(
    (
      eventName: AnalyticsEventName,
      eventData: AnalyticsEventData,
      eventImportance?: AnalyticsEventImportance,
    ) => {
      logAnalyticsEvent(
        eventName,
        {
          ...eventData,
          package_version: PACKAGE_VERSION as string,
          package_name: '@cbhq/identity-navigation',
          projectId,
          clientAction: action,
          locale,
        },
        eventImportance,
      );
    },
    [projectId, action, locale],
  );

  return useMemo(() => ({ logEvent }), [logEvent]);
}
